module.exports = __webpack_public_path__ + "static/media/prov.24b0c470.jfif";